import { CurrentPractitionerQuery, PractitionerDetails } from '@dreryk/egabinet-personnel-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';

import { PractitionerSafePresenter } from '~libs.desktop.shared.practitioner-safe-presenter';

import { commonTranslationKeys } from '../../../../../translations';
import { MedicalLeaveFormSection } from '../MedicalLeaveFormSection';

export const MedicalLeavePractitionerSection = (): JSX.Element | null => {
   const { data: currentPractitioner } = useCqrsGet<PractitionerDetails>(() => {
      return new CurrentPractitionerQuery();
   });

   if (!currentPractitioner) {
      return null;
   }

   return (
      <MedicalLeaveFormSection title={commonTranslationKeys.doctorData}>
         <PractitionerSafePresenter
            testId={'practitioner'}
            practitioner={currentPractitioner}
            type={'text'}
            withIdentification
         />
      </MedicalLeaveFormSection>
   );
};
